import type { HelpFile } from '../../types/help'
import { TimeSwitchTestIds } from '../../../testids/TimeSwitchTestIds'

export const timeSwitchHelp: HelpFile = {
  docPage: '/docs/admin/time-travel',
  texts: {
    [TimeSwitchTestIds.btnTimeSwitch]: null,
    [TimeSwitchTestIds.btnSetTime]: 'Die simulierte aktuelle Zeit setzen, die für zeitabhängige Prüfungen wie Zugriffsgültigkeit verwendet wird.',
    [TimeSwitchTestIds.btnResetTime]: 'Die simulierte Zeit auf die echte aktuelle Zeit zurücksetzen.',
    [TimeSwitchTestIds.btnAdvance1Day]: 'Die simulierte Zeit um einen Tag vorrücken, um das Verhalten am Folgetag zu prüfen.',
    [TimeSwitchTestIds.btnAdvance7Days]: 'Die simulierte Zeit um sieben Tage vorrücken, um das Verhalten in der nächsten Woche zu prüfen.',
    [TimeSwitchTestIds.btnAdvance30Days]: 'Die simulierte Zeit um dreißig Tage vorrücken, um das Verhalten am Monatsende zu prüfen.',
    [TimeSwitchTestIds.timeSwitchInput]: 'Datum und Uhrzeit, auf die die simulierte Uhr beim Klick auf Setzen springen soll.',
  },
}
